// extracted by mini-css-extract-plugin
export var closeButton = "_35-3";
export var header = "_35-0";
export var link = "_35-1";
export var retryButton = "_35-2";